module.exports = __webpack_public_path__ + "img/quantity-plus.00ea58fc.svg";